import Vue from 'vue'
import _ from 'lodash'
import NoteTemplate from '../../js/noteTemplates/NoteTemplate'
import { allNoteHelpers } from '../../js/noteTemplates/noteHelpers'

export const updateNoteTemplates = (state, noteTemplates) => {
  state.noteTemplates = noteTemplates
}

// These three mutations are mostly for updating the state from firestore
export const addNoteTemplate = (state, newNoteTemplate) => {
  Vue.set(state.noteTemplates, newNoteTemplate.id, newNoteTemplate)
  if (newNoteTemplate.enabled) {
    Vue.set(state.loadedNoteTemplates, newNoteTemplate.id, new NoteTemplate(newNoteTemplate))
  }
}

export const removeNoteTemplate = (state, idToRemove) => {
  Vue.delete(state.noteTemplates, idToRemove)
  if (idToRemove in state.loadedNoteTemplates) {
    Vue.delete(state.loadedNoteTemplates, idToRemove)
  }
}

function updateNotesWithThisTemplate (noteTemplateId) {
  allNoteHelpers().forEach(nh => {
    if (nh._getNoteTemplateId() === noteTemplateId) {
      nh.noteTemplate = null
      nh._updateNoteTemplate()
      nh.refreshEditor()
    }
  })
}

export const modifyNoteTemplate = (state, noteTemplateToModify) => {
  if (_.isEqual(state.noteTemplates[noteTemplateToModify.id], noteTemplateToModify)) {
    console.log('noteTemplate contents identical so not modified: ' + noteTemplateToModify.id)
    return
  }
  Vue.set(state.noteTemplates, noteTemplateToModify.id, noteTemplateToModify)
  if (noteTemplateToModify.enabled) {
    Vue.set(state.loadedNoteTemplates, noteTemplateToModify.id, new NoteTemplate(noteTemplateToModify))
  } else {
    if (noteTemplateToModify.id in state.loadedNoteTemplates) {
      Vue.delete(state.loadedNoteTemplates, noteTemplateToModify.id)
    }
  }
  updateNotesWithThisTemplate(noteTemplateToModify.id)
}
